import React from 'react';
import { Button, Box } from '@mui/material';
import { SanityCTA } from 'src/types/sanity/types.sanity.topNav';
import { navigate } from 'gatsby';

interface TopNavCTAsProps {
  ctas: SanityCTA[] | null;
}

interface RouteProps {
  link: string;
  path: string;
  target: string;
  page: {
    slug: {
      current: string;
    };
  };
}

const TopNavCTAs = ({ ctas }: TopNavCTAsProps) => {
  if (!ctas) return null;

  const handleClick = (route: RouteProps) => {
    const slug = route?.page?.slug?.current;
    const path = route?.path;
    const link = route?.link;

    if (slug) {
      navigate(`/${slug}`);
      return;
    } else if (path) {
      navigate(path);
      return;
    } else if (link) {
      if (typeof window !== 'undefined') {
        window.location.href;
        return;
      }
    } else {
      return;
    }

    navigate(route.path ? route.path : route.link);
  };

  return (
    <>
      <Box
      display={'flex'}
      justifyContent={'space-between'}
      gap={1}
      >
        {ctas.map(cta => (
          <Button
            key={cta.label}
            onClick={() => handleClick(cta.route)}
            size="small"
            sx={{
              whiteSpace: 'nowrap',
              background: cta.customColor.hex,
              color: 'white',
              padding: ['4px 16px', '4px 24px', '6px 36px'], // Adjust padding values as needed
              minHeight: ['18px', '24px'], // Adjust to reduce the overall button height
              '&:hover': {
                background: cta.customColor.hex,
                color: 'white',
              },
            }}
          >
            {cta.label}
          </Button>
        ))}
      </Box>
    </>
  );
};

export default TopNavCTAs;
